<script>
  export let bgcolor;
  export let height;
  export let style = "";
  export let widgets;

  import Icon from "./helpers/Icon.svelte";
  import { debug } from "./store.js";

  const headerStyle = `${style} --bg-color: ${bgcolor}; --height: ${height}`;

  import Heading from "./widgets/Heading.svelte";
  import Image from "./widgets/Image.svelte";
  import Text from "./widgets/Text.svelte";
  import Puzzle from "./widgets/Puzzle.svelte";
  import Benefit from "./widgets/Benefit.svelte";
  import Audio from "./widgets/Audio.svelte";
  import Video from "./widgets/Video.svelte";
  import Link from "./widgets/Link.svelte";
  import Button from "./widgets/Button.svelte";
  import Margin from "./widgets/Margin.svelte";

  export const widgetDefs = {
    heading: Heading,
    image: Image,
    text: Text,
    puzzle: Puzzle,
    benefit: Benefit,
    audio: Audio,
    video: Video,
    link: Link,
    button: Button,
    margin: Margin,
  };
</script>

<header style={headerStyle}>
  <!-- svelte-ignore a11y-missing-attribute -->
  {#each Object.entries(widgets) as [position, widget]}
    <div class="locked-widget" class:debug={$debug} data-type={widget.type}>
      <svelte:component this={widgetDefs[widget.type]} {...widget} />
    </div>
  {/each}
  <!--{#if image}<img
      class="locked-header-left locked-header-img"
      src={image}
    />{/if}
  {#if content}
    <h2 class="locked-header-right">{content}</h2>
    <a href="https://google.de" target="_blank"
      ><Icon style="margin-right: 0.5rem;" src="assets/icons/info.png" /></a
    >
  {/if}-->
</header>

<style type="text/scss">
  header {
    background-color: var(--bg-color);
    height: var(--height);
    position: fixed;
    z-index: 997;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;

    /*
    margin-left: calc((100vw - var(--max-width)) / 2);
    padding: 0 0.5em;
    max-width: calc(var(--max-width) - 2em);
    width: calc(var(--max-width) - 2em);

    &:before {
      height: var(--height);
      background-color: var(--bg-color);
      width: 100%;
      position: fixed;
      content: "";
      left: 0;
      z-index: -1;
    }*/
  }

  :global(header *) {
    max-height: var(--height);
  }

  @media (max-width: 960px) {
  }
</style>
